import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { DwValidationError, DwValidationErrorResult, DwValidationItemType, DwValidationRule, DwValidationRuleBase } from '@devwareapps/devware-cap';
import { LicensesEntity } from '../../../meta-data/app-meta-data.service';

import * as moment_ from 'moment';
const moment = moment_;

const errorProperty = 'licenseExpiration';

@DwValidationRule({
    keyName: 'license_expiration_date_validator',
    display: 'License Expiration Date Validator',
    errorType: errorProperty,
    validationItemType: DwValidationItemType.formControl,
    messageTemplate: 'Expiration Date must be at least 30 days after Issue Date',
})
@Injectable()
export class DwLicenseExpirationValidationRule extends DwValidationRuleBase {
    createValidator(config?: any) {
        return ValidateLicenseExpiration(config);
    }

    getMessageTemplate(error: DwValidationError<any>, displayName: string, isSubmitted: boolean, messageTemplate?: string): string {
        return messageTemplate;
    }
}

export function ValidateLicenseExpiration(dateValidationConfig: any): ValidatorFn {
    return (control: AbstractControl) => {
        const license : LicensesEntity = control?.parent?.value || {};

        license.ExpirationDate = control.value;

        if (!license?.IssueDate || !license?.ExpirationDate) {
            return;
        }

        const issueDate = moment(license.IssueDate);
        const expirationDate = moment(license.ExpirationDate);

        const minExpirationDate = issueDate.add(30, 'days')

        if (expirationDate.isBefore(minExpirationDate)) {
            const result: DwValidationErrorResult<any> = {};
            result[errorProperty] = {
                value: true
            };

            return result;
        }

        return null;
    }
}
